import axios from "axios";
import { useEffect, useState } from "react";
import AntdBreadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import DoctorsFilterOptions from "../../components/Common/CommonFilterOptions";
import AssignedTo from "../../components/Modal/AssignedTo";
import Deletepopup from "../../components/Modal/Deletepopup";
import SucessModal from "../../components/Modal/SucessModal";
import { useLocation } from "react-router";
// Updated custom hook paths
import Actions from "../../components/Common/Actions";
import SelectComponent from "../../components/Common/Select";
import ListPageLayout from "../../components/Layout";
import useDebouncedSearch from "../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../components/Utils/hooks/useSortHandler";

const actions = [
  "Select",
  "Contacted",
  "Yet to Contact",
  "Registration Completed",
  "Assigned",
];

const InstaDocQrCore = () => {
  // Sorting
  const [sort, setSort] = useState("");
  const [sortName, setSortName] = useState("Newest First");
  const handleSortClick = useSortHandler(setSort, setSortName);
  const location = useLocation();
  // Search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () =>
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 })),
  );

  const [assignModal, setAssignModal] = useState({ id: "", status: false });
  const [success, setSuccess] = useState(false);
  const [loader, setLoader] = useState(true);

  // Delete state
  const [deleteId, setDeleteId] = useState("");
  const [showDelete, setShowDelete] = useState(false);

  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}insta-doc-qr-code/list`,
      initialParams: {
        sort,
        searchText: search,
      },
    });

  const handlePageChange = usePageChange(pagination, setPagination);
  const handleDelete = useDeleteHandler(
    "insta-doc-qr-code",
    fetchData,
    setShowDelete,
  );

  useEffect(() => {
    (!assignModal.status) && setLoader(true) 
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.skip, pagination.limit, sort, search]);

  const handleOptionChange = (e, id) => {
    setLoader(true)
    const selectedValue = e;
    const fields = {};

    fields.action = selectedValue;
    axios
      .patch(
        `${process.env.REACT_APP_API_URL}insta-doc-qr-code/update/${id}`,
        fields,
      )
      .then((response) => {
        fetchData();
      });

    if (selectedValue === "Delete") {
      setDeleteId({ id: id, status: true });
    }
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      fixed: "left",
      render: (text, record, index) =>
        Number(pagination.skip || 0) + (index + 1),
    },
    {
      title: "Pharmacy Partner ID",
      dataIndex: "pharmacy_partner_id",
      key: "pharmacy_partner_id",
      fixed: "left",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
    },
    {
      title: "Mobile No",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "Symptoms",
      dataIndex: "symptoms",
      key: "symptoms",
      render: (symptoms) =>
        symptoms.map((data, index) => (
          <span key={index}>
            {index > 0 && ", "}
            {data.value}
          </span>
        )),
    },
    {
      title: "City / Town",
      dataIndex: "city",
      key: "city",
    },
    {
      title: "Pincode",
      dataIndex: "pincode",
      key: "pincode",
    },
    {
      title: "App Download Android Click",
      dataIndex: "android_click",
      key: "android_click",
    },
    {
      title: "App Download iOS Click",
      dataIndex: "ios_click",
      key: "ios_click",
    },
    {
      title: "Brochure Icon Click Status",
      dataIndex: "brochure_click",
      key: "brochure_click",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div className="d-flex align-items-center">
          <SelectComponent
            props={{
              Array: actions,
              value: getSelectValue(record),
              style: { color: "#CB1B5B", width: "230px" },
              onChange: (e) => handleOptionChange(e, record.key),
            }}
          />
        </div>
      ),
    },
    {
      title: "Assigned to",
      dataIndex: "assigned_to",
      key: "assigned_to",
      render: (assignedTo) => assignedTo || "-",
    },
    {
      title: "Lead Action Stages",
      key: "lead_action_stages",
      render: (_, record) => (
        <Actions
          isAssignedTo={true}
          isDelete={true}
          onClickDelete={async () => {
            await setDeleteId(record?._id);
            await setShowDelete(true);
          }}
          onClickAssignedTo={() =>
            setAssignModal({ id: record.key, status: true })
          }
        />
      ),
    },
  ];

  const dataSource = records.map((el) => ({ ...el, key: el._id }));
  const getSelectValue = (data) => {
    return data?.action ? data?.action : "Select";
  };
  const breadcrumbsList = [
    { text: "RP QR InstaDoc", link: "/insta-doc-qr-code" },
  ];
  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);
  return (
    <ListPageLayout
      breadcrumbs={
        <AntdBreadcrumbs
          className="w-75 healthsyMasterBreadCrumbs"
          breadcrumbsList={breadcrumbsList}
        />
      }
      addButton={<></>}
      titles={<></>}
      filters={
        <DoctorsFilterOptions
          limit={pagination.limit}
          setLimit={(val) =>
            setPagination((prev) => ({
              ...prev,
              limit: val,
              skip: 0,
              currentPage: 1,
            }))
          }
          search={search}
          onChange={debouncedSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          filter_records={() => {}}
          setFilterShow={() => {}}
          showFilter={false}
        />
      }
      tableProps={{
        columns,
        dataSource,
        className: "mx-3 pt-2 table-scrollable medicineList_table",
      }}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
      loader={loader}
    >
      {/* Optional children like modals */}
      {showDelete && (
        <Deletepopup
          handleDelete={() => handleDelete(deleteId)}
          id={deleteId}
          handleClose={() => setShowDelete(false)}
        />
      )}
      {assignModal.status && (
        <AssignedTo
          id={assignModal.id}
          setAssignModal={setAssignModal}
          setSuccess={setSuccess}
        />
      )}
      {success && (
        <SucessModal
          name="BD"
          post="Assigned"
          page={location.pathname}
          onClick={() => handleDelete(deleteId)}
        />
      )}
    </ListPageLayout>
  );
};

export default InstaDocQrCore;
